import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Service } from '../models/service';
import { FormioForm } from '@formio/angular';
import { Task } from '../models/task';
import { Institution } from '../models/institution';
import { Message } from '../models/message';
import { BPASettings } from '@models/bpa-settings';

interface CachedBPASettings {
  settings: BPASettings;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalStateProviderService {
  drawerOpen: boolean = false;
  currentService: Service | null = null;
  execChange: Subject<Service | null> = new Subject<Service | null>();
  execFormioFormChange: Subject<FormioForm | null> =
    new Subject<FormioForm | null>();
  previousLabel = $localize`:@@Previous:Previous`;
  nextLabel = $localize`:@@Next:Next`;
  formioForm: FormioForm | null = null;
  formOpts: any = null;
  formSubmission: any = null;
  processHistory: Task[] = [];
  institutions: Institution[] = [];
  alerts: Message[] = [];

  // Subject for triggering the messages dialog to open from anywhere in the app
  openMessagesDialog$: Subject<void> = new Subject<void>();

  private readonly bpaSettingsSubject = new BehaviorSubject<BPASettings | null>(
    null
  );
  bpaSettings$ = this.bpaSettingsSubject.asObservable();

  private cachedBpaSettings: CachedBPASettings | null = null;

  getServiceChanged() {
    return this.execChange.asObservable();
  }

  serviceChanged(service: Service | null) {
    this.currentService = service;
    this.execChange.next(service);
  }

  getLoadedFormChanged() {
    return this.execFormioFormChange.asObservable();
  }

  loadedFormChanged(
    form: FormioForm | null,
    formOpts: any,
    formSubmission: any,
    processHistory: any
  ) {
    this.formioForm = form;
    this.formOpts = formOpts;
    this.formSubmission = formSubmission;
    this.processHistory = processHistory;
    this.execFormioFormChange.next(form);
  }

  constructor() {}

  updateBpaSettings(settings: BPASettings) {
    this.bpaSettingsSubject.next(settings);
    this.cachedBpaSettings = {
      settings,
      timestamp: Date.now()
    };
  }

  getBpaSettings(): BPASettings | null {
    return this.bpaSettingsSubject.getValue();
  }

  getCachedBpaSettings(): CachedBPASettings | null {
    return this.cachedBpaSettings;
  }

  openMessagesDialog(): void {
    this.openMessagesDialog$.next();
  }
}
